import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqAndCta() {
  return (
    <>
      <section className="py-14 md:py-20">
        <div className="container-site">
          <div className="grid gap-8 lg:grid-cols-[2fr_1fr]">
            <div>
              <SectionHeader
                eyebrow="常见问题"
                title="追漫之前，先看这里"
                subtitle="关于题材收录、更新与反馈的常见疑问，一次性为你解答。"
              />
              <FaqAccordion items={faqs.slice(0, 4)} />
              <Link to="/faq" className="btn btn-ghost mt-6">
                查看全部常见问题
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="card flex flex-col justify-between bg-primary-50 p-6">
              <div>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-hand-heart-line text-2xl" />
                </span>
                <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950">想看的漫画还没找到？</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  无论是想推荐心爱的作品，还是对我们的内容有任何建议，都欢迎告诉我们。你的每一次分享，都可能让更多同好看到好作品。
                </p>
              </div>
              <Link to="/contact" className="btn btn-primary mt-6 w-full">
                联系我们 / 投稿
                <i className="ri-send-plane-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden py-16 md:py-24">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20fantasy%20landscape%20at%20golden%20dusk%20with%20silhouette%20of%20a%20giant%20fairy%20tree%20and%20floating%20embers%2C%20stylized%20digital%20painting%2C%20warm%20amber%20and%20deep%20emerald%20palette%2C%20cinematic&width=1600&height=700&seq=cta-fairy-dusk&orientation=landscape"
            alt=""
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40" />
        </div>
        <div className="container-site relative text-center">
          <h2 className="mx-auto max-w-2xl font-heading text-2xl font-bold text-background-50 md:text-3xl">
            异世界、精灵与妖怪的故事，永远比你想象的更多
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90">
            从热门妖精漫画分类到故事简介，从这里开启你的奇幻追漫之旅。
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/category/elf" className="btn btn-accent w-full px-7 py-3 sm:w-auto">
              立即选漫
            </Link>
            <Link to="/about" className="btn w-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto">
              了解妖精漫画堂
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}